import React from 'react';
import './style.css';
import config from '../../config';
import { FacebookShareButton, FacebookIcon } from 'react-share';
import { Button, Icon, List } from 'semantic-ui-react'
import Footer from '../Footer';

export const Submission = ({ campaign, data, videoLink }) => {
  const selectedValues = campaign.socialMediaOption ? JSON.parse(campaign.socialMediaOption) : [];
  const foundGoogleReview = selectedValues.find(element => element === 'googleReviews');
  const foundAmazonReviews = selectedValues.find(element => element === 'amazonReviews');
  const foundFacebook = selectedValues.find(element => element === 'facebook');
  const fileUrl = `${config.AWS.SiteAssets}/${data[0].path}`;

  return (
    <div className='submission'>
      <p>
        {campaign.thankyouMessage ? campaign.thankyouMessage : "Thank you for your submission"}
      </p>

      {campaign.thankYouPageLink && (
        <p><a href={campaign.thankYouPageLink} target="_blank">{campaign.thankYouPageLink}</a></p>
      )}

      <List divided relaxed>
        {foundGoogleReview && (
          <List.Item>
            <List.Content>
              <List>
                <a href={campaign.googleReviewLink} target="_blank">
                  <Button color='google'>
                    <Icon name='google' />Sign in with Google
                  </Button>
                </a>
              </List>
            </List.Content>
          </List.Item>
        )}

        {(foundFacebook && videoLink) && (
          <List.Item>
            <List.Content>
              <List>
                <FacebookShareButton
                  url={videoLink || fileUrl}
                  quote={`Check out my video for ${campaign.name}`}
                  className="Demo__some-network__share-button fbButton">
                  <FacebookIcon size={32} round />
                </FacebookShareButton>
              </List>
            </List.Content>
          </List.Item>
        )}

        {foundAmazonReviews && (
          <List.Item>
            <List.Content>
              <a href={campaign.amazonReviewLink} target="_blank">
                <Button color='amazon'>
                  <Icon name='amazon' /> Login with amazon
                </Button>
              </a>
            </List.Content>
          </List.Item>
        )}

      </List>
      <Footer campaign={campaign} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Submission/Submission.js